/* eslint-disable @typescript-eslint/no-explicit-any */
import { announcementsLinks } from '@/backend/config/routes';
import { AnnouncementColumns } from '@juvare/announcements/backend/features/announcements';
import { AnnouncementCreateOrEdit } from '@juvare/announcements/ui/features/announcements';
import { AppPage } from '@juvare/common-web-ui/AppPage';
import { AppPageHeader2 } from '@juvare/common-web-ui/AppPageHeader2';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export const AnnouncementsForm = () => {
    const { requireAnySystemPermission } = usePermission();
    const location = useLocation();
    const announcement = (location.state as { entity: Row<AnnouncementColumns> }) || undefined;
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { t } = useTranslation('healthAlerts');

    const navigateToAnnouncements = () => {
        navigate(announcementsLinks.root);
    };

    return (
        <AppPage
            contentPadding={2}
            contentScrollable={true}
            header={
                <AppPageHeader2
                    title={t('panels.home.title')}
                    subTitle={t('announcement.announcements')}
                    onBack={() =>
                        navigationContext.navigate(() => {
                            navigationContext.clearChanged();
                            navigateToAnnouncements();
                        }, true)
                    }
                />
            }
            contentWidth={800}
        >
            <AnnouncementCreateOrEdit
                onEditAnnouncement={navigateToAnnouncements}
                onCreateAnnouncement={navigateToAnnouncements}
                announcementData={
                    announcement?.entity && {
                        ...announcement.entity,
                        columns: {
                            ...announcement.entity.columns,
                            access: {
                                public: announcement.entity.columns.public,
                                visibility: announcement.entity.columns.visibility,
                            },
                        } as AnnouncementColumns,
                    }
                }
                extendedConfig={
                    [
                        {
                            type: 'contactManagement.accessByOrganization',
                            label: 'Access',
                            key: 'access',
                            hidePublicOption: !requireAnySystemPermission('manage-announcements'),
                        },
                    ] as any
                }
            />
        </AppPage>
    );
};
